import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHandshakeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M6.25 4.75H4.25C3.14543 4.75 2.25 5.64543 2.25 6.75V10.2574C2.25 11.053 2.56607 11.8161 3.12868 12.3787L4.375 13.625C4.85825 14.1082 5.64175 14.1082 6.125 13.625C6.60825 13.1418 6.60825 12.3582 6.125 11.875L6 11.75L6.875 12.625C7.35825 13.1082 8.14175 13.1082 8.625 12.625C9.10825 12.1418 9.10825 11.3582 8.625 10.875L8.5 10.75L9.375 11.625C9.85825 12.1082 10.6418 12.1082 11.125 11.625C11.6082 11.1418 11.6082 10.3582 11.125 9.875L11 9.75L11.875 10.625C12.3582 11.1082 13.1418 11.1082 13.625 10.625C14.1082 10.1418 14.1082 9.35825 13.625 8.875L10.75 6" }), /* @__PURE__ */ _jsx("path", { d: "M13.75 8.75V4.75C13.75 3.64543 12.8546 2.75 11.75 2.75H9.74264C8.94699 2.75 8.18393 3.06607 7.62132 3.62868L5.75 5.5C5.19772 6.05228 5.19772 6.94772 5.75 7.5C6.30228 8.05228 7.19772 8.05228 7.75 7.5L9.5 5.75H11.25" })]
});
export default SvgHandshakeIcon;
